import { put, select, takeEvery } from "redux-saga/effects";
import { DevService, HttpService } from "src/services";
import { ConfigInitAction, UserSessionAction } from "../actions";
import { ConfigInitTypes } from "../types";
import { ReduxAction, UserSession } from "../models";
import { Urls } from "src/constants";
import { AxiosResponse } from "axios";
import { replace } from "connected-react-router";
import { history } from "..";
import FingerprintJS, { Agent, GetResult } from "@fingerprintjs/fingerprintjs";


export function* ConfigInitSaga() {
    yield takeEvery(ConfigInitTypes.REQUEST_LOAD_CONFIG_INIT, requestConfig);
}

function* requestConfig(action: ReduxAction) {

    try {
        const { loginParam, iranLeagueParam } = action.payload;
        yield loginFromParam(loginParam);
        yield loginForIranLeague(iranLeagueParam);
        const user: UserSession = yield select((state: any) => state.UserState);

        if (user.loggedIn || DevService.loginFromVue()) {
            yield put(UserSessionAction.requestUserInfo());
        }

        const api = Urls.config.get();
        const response: AxiosResponse = yield HttpService.Fetch(api);

        if (response.data) {
            yield put(ConfigInitAction.setData(response.data));
        }

        if (loginParam || iranLeagueParam) {
            yield put(replace(history.location.pathname));
        }
    }
    catch {
        yield put(ConfigInitAction.hideLoading());
    }

}

function* loginForIranLeague(param?: string | null) {
    try {
        if (!param) return;

        const user: UserSession = yield select((state: any) => state.UserState);
        if (user.loggedIn) return;

        const api = Urls.auth.loginInIranLeague();

        const decoded = DevService.decodeJwt(param);
        if (!decoded?.Phone) return;
        const phone = decoded.Phone;

        const fpPromise = FingerprintJS.load();
        const fp: Agent = yield fpPromise;
        const result: GetResult = yield fp.get();
        const visitorId = result.visitorId;

        const visitorIdHalf = Math.floor(visitorId.length / 2);
        const phoneHalf = Math.floor(phone.length / 2);

        const deviceInfo = {
            manufacturer: "Desktop",
            platform: 4,
            screenWidth: window.outerWidth,
            screenHeight: window.outerHeight,
            udid: `${visitorId.substring(0, visitorIdHalf)}${phone.substring(phoneHalf)}${visitorId.substring(visitorIdHalf)}${phone.substring(0, phoneHalf)}`,
        };

        const response: AxiosResponse = yield HttpService.Fetch(api, { deviceInfo, token: param });

        if (!response.data) return;

        yield put(UserSessionAction.login(response.data));
    }
    catch { }
}


function* loginFromParam(param?: string | null) {
    try {
        if (!param) return;

        const user: UserSession = yield select((state: any) => state.UserState);
        if (user.loggedIn) return;

        const api = Urls.auth.loginFromParam();

        const fpPromise = FingerprintJS.load();
        const fp: Agent = yield fpPromise;
        const result: GetResult = yield fp.get();
        const visitorId = result.visitorId;

        const visitorIdHalf = Math.floor(visitorId.length / 2);
        const phoneHalf = Math.floor(param.length / 2);

        const model = {
            manufacturer: "Desktop",
            platform: 4,
            screenWidth: window.outerWidth,
            screenHeight: window.outerHeight,
            udid: `${visitorId.substring(0, visitorIdHalf)}${param.substring(phoneHalf)}${visitorId.substring(visitorIdHalf)}${param.substring(0, phoneHalf)}`,
            p: param,
        };

        const response: AxiosResponse = yield HttpService.Fetch(api, model);

        if (!response.data || !response.data.affective) return;

        yield put(UserSessionAction.login(response.data.session));

    }
    catch {

    }
}